var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],attrs:{"x-small":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.restore()}}},[_vm._v("mdi-restore")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }